import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import Sidebar from 'components/Sidebar/Sidebar';

class SideBar extends Component {
  static propTypes = {
    onSetOpen: PropTypes.func,
    routes: PropTypes.array,
    groupMenu: PropTypes.object,
    subGroup: PropTypes.any,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  // get route which has menu and menu name,
  // if menu has custom condition, it's will be evaluated
  sideBarItems = () => {
    let menu = [];
    const { routes } = this.props;

    let menuItems = routes
      .filter(route => {
        return route.menu;
      })
      .sort((a, b) => {
        if (!a.menu.order) {
          return -1;
        }
        if (!b.menu.order) {
          return 1;
        }
        return a.menu.order - b.menu.order;
      });

    menuItems.forEach(route => {
      let condition =
        route.menu && typeof route.menu.condition === 'function'
          ? route.menu.condition()
          : true;
      if (route.menu && route.menu.name && condition) {
        menu.push(route);
      }
    });

    return menu;
  };

  render() {
    return (
      <Sidebar
        items={this.sideBarItems()}
        groupMenu={this.props.groupMenu}
        //logo={AppSettings.LOGO_30}
        location={this.props.location}
        subGroup={this.props.subGroup}
        //displayName={this.props.user.fullName}
      >
        {/* <nav class="navbar navbar-fixed-top side-menu-container" id="sidebar-wrapper" role="navigation"> */}
        {/* </nav> */}
      </Sidebar>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(SideBar);



// WEBPACK FOOTER //
// ./src/sidebar.js